import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import type { PapiDeviation } from '@wix/da-papi-types';
import s from './CardHeading.scss';

interface Props {
  deviation: PapiDeviation;
  children: React.ReactNode;
  className?: string;
}

const CardHeading: React.FC<Props> = ({ deviation, children, className }) => {
  const { t } = useTranslation();
  return (
    <Heading className={c(s['root'], className)}>
      <span className={s['prefix']}>
        {deviation.isPublished
          ? t('sidebar.exclusives.heading.prefix.published')
          : t('sidebar.exclusives.heading.prefix.private')}
      </span>
      <span className={s['exclusive-type']}>{children}</span>
    </Heading>
  );
};

CardHeading.displayName = 'CardHeading';

export default CardHeading;
